module.exports = __webpack_public_path__ + "img/page14.de98956e.jpg";